import { render, staticRenderFns } from "./ListActions.vue?vue&type=template&id=1240585b&"
import script from "./ListActions.vue?vue&type=script&lang=js&"
export * from "./ListActions.vue?vue&type=script&lang=js&"
import style0 from "./ListActions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports